import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromLayoutSelectors from '../../../store/selectors/layout.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-footer-content',
  standalone: false,
  styleUrls: ['./footer-content.component.scss'],
  templateUrl: './footer-content.component.html'
})
export class FooterContentComponent {
  private store = inject(Store);

  useMobileLayout$: Observable<boolean>;

  constructor() {
    this.useMobileLayout$ = this.store.pipe(select(fromLayoutSelectors.selectUseMobileLayout));
  }
}
